module.exports = __webpack_public_path__ + "static/portfolio_gallery_13-ac4d434c8f171d917e2371551d80f189.jpg";